(function(){var root=document.querySelector('[data-pbnk-order-flow]');
if(!root||root.__pbnkFlowInit)return;
root.__pbnkFlowInit=true;
var rootCountry=String(root.getAttribute('data-country')||'').toUpperCase(),lang=root.getAttribute('data-lang')||'en',isUS=root.getAttribute('data-is-us')==='true'||rootCountry==='US',isUK=lang==='en-gb'||rootCountry==='GB'||rootCountry==='UK',sizeIdx=parseInt(root.getAttribute('data-size-index'),10),detailIdx=parseInt(root.getAttribute('data-detail-index'),10),frameIdx=parseInt(root.getAttribute('data-frame-index'),10);
if(isNaN(sizeIdx))sizeIdx=0;
if(isNaN(frameIdx))frameIdx=1;
if(isNaN(detailIdx))detailIdx=2;
var bundleDiscountUsdCents=parseInt(root.getAttribute('data-bundle-discount-usd-cents'),10);
if(isNaN(bundleDiscountUsdCents)||bundleDiscountUsdCents<0)bundleDiscountUsdCents=500;
var variants=[];
try{variants=JSON.parse(root.getAttribute('data-variants')||'[]')||[]}catch(e){variants=[]}var optionCount=variants[0]&&variants[0].options?variants[0].options.length:3,selected=new Array(optionCount).fill(null),form=root.querySelector('#pbnk-ajax-product-form'),idInput=root.querySelector('[data-pbnk-variant-id]'),qtyInput=root.querySelector('[data-pbnk-qty]'),priceEl=root.querySelector('[data-pbnk-atc-price]'),textEl=root.querySelector('[data-pbnk-atc-text]'),btnEl=root.querySelector('[data-pbnk-atc]'),dyn=root.querySelector('[data-pbnk-dynamic-checkout]'),cartMsg=root.querySelector('[data-pbnk-cart-message]'),uploadStatus=root.querySelector('[data-pbnk-upload-status]'),addonChecks=root.querySelectorAll('[data-addon-check]'),frameQuestion=root.querySelector('[data-frame-question]'),frameInterestButtons=root.querySelectorAll('[data-frame-interest]'),frameOfferChoice=null,frameAddon=root.querySelector('[data-frame-addon]'),frameThumbs=root.querySelector('[data-frame-thumbs]'),frameColors=root.querySelector('[data-frame-colors]'),frameColorError=root.querySelector('[data-frame-color-error]'),frameWarning=root.querySelector('[data-frame-warning]'),frameProduct=null,frameSelectedVariant=null,lightbox=root.querySelector('[data-pbnk-lightbox]'),lightboxImg=lightbox?lightbox.querySelector('[data-lightbox-img]'):null,lightboxThumbs=lightbox?lightbox.querySelector('[data-lightbox-thumbs]'):null,lightboxDialog=lightbox?lightbox.querySelector('[data-lightbox-dialog]'):null,frameImages=[],lightboxIndex=0,lockedScrollY=0,moneyFormat=root.getAttribute('data-money-format')||'${{amount}}',shopCurrency=root.getAttribute('data-shop-currency')||'USD',pbnkLang=root.getAttribute('data-lang')||'en',ready=false,activeVariant=null,lastGuideStep=null,guideInitialized=false,scrollTimer=null;
var progressTextEl=root.querySelector('[data-pbnk-progress-text]'),progressBarEl=root.querySelector('[data-pbnk-progress-bar]');
var uploadWrap=root.querySelector('.pbnk-upload-wrap'),frameAddonCheck=root.querySelector('[data-frame-addon-check]'),frameFit=root.querySelector('[data-frame-fit]'),themePriceGeneration=0;
function t(en,nl,enGb){return lang==='nl'?nl:(isUK&&enGb?enGb:en)}
function miniPicker(){var w=root.closest('.m-main-product--wrapper')||document.querySelector('.m-main-product--wrapper');
return w?w.querySelector('variant-picker'):null}
function hidePicker(vp){if(vp&&!vp.classList.contains('pbnk-visually-hidden')){vp.classList.add('pbnk-visually-hidden');
vp.setAttribute('aria-hidden','true')}}
function esc(s){return String(s).replace(/["\\]/g,'\\$&')}
function findExact(opts){for(var i=0;
i<variants.length;
i++){var v=variants[i],ok=true;
for(var j=0;
j<opts.length;
j++){if(!opts[j]||!v.options||v.options[j]!==opts[j]){ok=false;
break}}if(ok)return v}return null}
function setActive(idx,val){var g=root.querySelector('[data-pbnk-field][data-option-index="'+idx+'"]');
if(!g)return;
var s=g.querySelector('[data-pbnk-select]');
if(s){s.value=val||'';
return}g.querySelectorAll('.pbnk-tile-btn').forEach(function(b){var a=val&&b.getAttribute('data-value')===val;
b.classList.toggle('is-active',!!a);
b.setAttribute('aria-pressed',a?'true':'false')})}
function syncMini(variant){if(!variant||!variant.options)return;
var vp=miniPicker();
if(!vp)return;
hidePicker(vp);
var fields=Array.prototype.slice.call(vp.querySelectorAll('[data-picker-field]'));
if(!fields.length)return;
variant.options.forEach(function(opt,idx){var f=fields[idx];
if(!f)return;
var type=f.dataset&&f.dataset.pickerField?f.dataset.pickerField:'';
if(type==='radio'){var inp=f.querySelector('input[type="radio"][value="'+esc(opt)+'"]');
if(inp&&!inp.checked){inp.checked=true;
inp.dispatchEvent(new Event('change',{bubbles:true}))}if(typeof f.updateSelectedValue==='function'){try{f.updateSelectedValue()}catch(e){}}return}var sel=f.querySelector('select');
if(sel&&sel.value!==opt){sel.value=opt;
sel.dispatchEvent(new Event('change',{bubbles:true}))}if(typeof f.updateSelectedValue==='function'){try{f.updateSelectedValue()}catch(e){}}});
vp.dispatchEvent(new Event('change',{bubbles:true}))}
function updateURL(id){if(!id)return;
try{var u=new URL(window.location.href);
u.searchParams.set('variant',String(id));
window.history.replaceState({},'',u.toString())}catch(e){}}
function money(cents){var n=typeof cents==='number'?cents:parseInt(cents,10);
if(isNaN(n))return'';
var fmt=window.Shopify&&Shopify.money_format?Shopify.money_format:moneyFormat;
if(window.Shopify&&typeof Shopify.formatMoney==='function')return Shopify.formatMoney(n,fmt);
try{var htmlLang=document.documentElement.getAttribute('lang')||'en',cur=window.Shopify&&Shopify.currency&&Shopify.currency.active?Shopify.currency.active:shopCurrency;
return new Intl.NumberFormat(htmlLang,{style:'currency',currency:cur}).format(n/100)}catch(e){return(n/100).toFixed(2)}}
function updateThemePrice(variant){if(!variant)return;
var priceText=money(variant.price);
var hasCompare=variant.compare_at_price&&variant.compare_at_price>variant.price;
var compareText=hasCompare?money(variant.compare_at_price):'';
var discount=hasCompare?Math.round(((variant.compare_at_price-variant.price)/variant.compare_at_price)*100):0;
var scopes=[];
var productWrap=root.closest('.m-main-product--wrapper');
if(productWrap)scopes.push(productWrap);
var mainProduct=root.closest('.m-main-product');
if(mainProduct&&scopes.indexOf(mainProduct)===-1)scopes.push(mainProduct);
scopes.push(document);
function valid(el){return el&&!root.contains(el)}
function each(selector,cb){var seen=[];
scopes.forEach(function(scope){Array.prototype.slice.call(scope.querySelectorAll(selector)).forEach(function(el){if(seen.indexOf(el)>-1)return;
seen.push(el);
if(valid(el))cb(el)})})}each('.m-price-item.m-price-item--sale,.m-price-item--sale,.m-price__sale .m-price-item--sale',function(el){el.textContent=priceText;
el.style.display=''});
each('.m-price__regular .m-price-item--regular',function(el){if(!hasCompare){el.textContent=priceText;
el.style.display=''}else{el.style.display='none'}});
each('.m-price-item--compare,.m-price__sale .m-price-item--regular',function(el){if(hasCompare){el.textContent=compareText;
el.style.display=''}else{el.style.display='none'}});
each('[data-product-price],[data-price]:not([data-compare-price])',function(el){el.textContent=priceText});
each('[data-compare-price]',function(el){if(hasCompare){el.textContent=compareText;
el.style.display=''}else{el.style.display='none'}});
each('.m-price,.price,.product__price',function(el){el.classList.toggle('m-price--on-sale',!!hasCompare);
el.classList.toggle('price--on-sale',!!hasCompare)});
each('[data-saved-price],.m-currency--saved',function(el){if(hasCompare){el.textContent=discount+'%';
el.style.display=''}else{el.style.display='none'}});
each('.m-price__badge-sale,.m-product-tag--sale,.prod__tag-discounted,.m-badge--sale,.sale-badge,[data-sale-badge]',function(el){if(hasCompare){el.style.display=''}else{el.style.display='none'}})}
function updateThemePriceSoon(variant){if(!variant)return;
var generation=++themePriceGeneration;
function sync(){if(generation===themePriceGeneration)updateThemePrice(variant)}sync();
setTimeout(sync,0);
setTimeout(sync,80);
setTimeout(sync,250);
setTimeout(sync,600)}
function updateInitialThemePriceSoon(variant){if(!variant)return;
var generation=++themePriceGeneration;
function sync(){if(generation===themePriceGeneration&&!activeVariant)updateThemePrice(variant)}sync();
setTimeout(sync,0);
setTimeout(sync,80);
setTimeout(sync,250);
setTimeout(sync,600)}
function lock(stepName,locked){var step=root.querySelector('[data-pbnk-step="'+stepName+'"]');
if(!step)return;
step.classList.toggle('is-locked',!!locked);
if(stepName==='buy')return;
step.querySelectorAll('button,select,textarea,input').forEach(function(el){if(el.type==='hidden'||stepName==='upload')return;
el.disabled=!!locked})}
function dynDisabled(disabled){if(!dyn)return;
dyn.classList.toggle('is-disabled',!!disabled);
dyn.querySelectorAll('button,input[type="submit"]').forEach(function(el){if(disabled){el.setAttribute('disabled','disabled');
el.setAttribute('aria-disabled','true')}else{el.removeAttribute('disabled');
el.setAttribute('aria-disabled','false')}})}
function msg(m){if(!cartMsg)return;
if(!m){cartMsg.textContent='';
cartMsg.classList.remove('is-visible');
return}cartMsg.textContent=m;
cartMsg.classList.add('is-visible')}
function buyState(variant){activeVariant=variant||null;
if(!ready){if(btnEl)btnEl.setAttribute('disabled','disabled');
if(textEl)textEl.textContent=t('Complete your choices','Maak je keuzes compleet');
if(priceEl)priceEl.textContent='';
dynDisabled(true);
return}if(!variant){if(btnEl)btnEl.setAttribute('disabled','disabled');
if(textEl)textEl.textContent=t('Unavailable','Niet beschikbaar');
if(priceEl)priceEl.textContent='';
dynDisabled(true);
return}if(idInput)idInput.value=String(variant.id);
if(variant.available===false){if(btnEl)btnEl.setAttribute('disabled','disabled');
if(textEl)textEl.textContent=t('Sold out','Uitverkocht');
if(priceEl)priceEl.textContent='';
dynDisabled(true);
return}if(btnEl)btnEl.removeAttribute('disabled');
if(textEl)textEl.textContent=t('Create My Custom Kit','Maak mijn schilderpakket');
if(priceEl)priceEl.textContent=money(variant.price);
dynDisabled(false)}
function uploaded(){var area=root.querySelector('.uploadkit');
if(!area)return false;
var nodes=area.querySelectorAll('input[name^="properties["],textarea[name^="properties["],select[name^="properties["]');
for(var i=0;
i<nodes.length;
i++){var val=nodes[i].value!=null?String(nodes[i].value).trim():'';
if(val!=='')return true}var hidden=area.querySelectorAll('input[type="hidden"]');
for(var j=0;
j<hidden.length;
j++){var h=hidden[j].value!=null?String(hidden[j].value).trim():'';
if(h.length>6&&(h.indexOf('http')===0||h.indexOf('/cdn/')>-1||h.toLowerCase().indexOf('upload')>-1))return true}var links=area.querySelectorAll('a[href]');
for(var k=0;
k<links.length;
k++){var href=links[k].getAttribute('href')||'';
if(href&&href!=='#'&&href.indexOf('javascript:')!==0)return true}return false}
function stepEl(name){return root.querySelector('[data-pbnk-step="'+name+'"]')}
function ensureHint(el){if(!el)return null;
var h=el.querySelector('[data-pbnk-focus-hint]');
if(!h){h=document.createElement('p');
h.className='pbnk-step-focus-hint';
h.setAttribute('data-pbnk-focus-hint','');
el.appendChild(h)}return h}
function hintText(step){if(lang==='nl'){if(step==='upload')return 'Begin hier met het uploaden van je foto.';
if(step==='size')return 'Ga hier verder en kies je canvasformaat.';
if(step==='detail')return 'Kies nu je detailniveau.';
if(step==='frame')return 'Kies nu je frame optie.';
if(step==='upsell')return 'Controleer deze extra opties voordat je bestelt.';
if(step==='buy')return 'Je keuzes zijn compleet. Je kunt nu je bestelling plaatsen.';
return 'Ga hier verder.'}else{if(step==='upload')return 'Start here by uploading your photo.';
if(step==='size')return 'Continue here and choose your canvas size.';
if(step==='detail')return 'Now select your detail level.';
if(step==='frame')return 'Now choose your frame option.';
if(step==='upsell')return 'Review these add-ons before ordering.';
if(step==='buy')return 'Your choices are complete. You can now place your order.';
return 'Continue here.'}}
function setGuide(current,completed){var names=['upload','size','detail','frame','upsell','buy'];
names.forEach(function(n){var el=stepEl(n);
if(!el)return;
var done=completed.indexOf(n)>-1;
el.classList.toggle('is-complete',done);
el.classList.toggle('is-current',n===current);
var num=el.querySelector('.pbnk-step-num');
if(num&&!num.getAttribute('data-original-step-num'))num.setAttribute('data-original-step-num',num.textContent.trim());
if(num)num.textContent=num.getAttribute('data-original-step-num');
var hint=ensureHint(el);
if(hint)hint.textContent=hintText(n)})}
function scrollToGuide(step){lastGuideStep=step;
guideInitialized=true}
function normalizedSize(v){return String(v||'').toLowerCase().replace(/[×x]/g,'x').replace(/\s+/g,'').replace(/cm/g,'')}
function frameSizeAllowed(){var v=normalizedSize(selected[sizeIdx]);
return ['30x40','40x40','40x50','50x60'].some(function(x){return v.indexOf(x)>-1})}
function isNoFrameValue(value){var v=String(value||'').toLowerCase();
return v.indexOf('no frame')>-1||v.indexOf('without frame')>-1||v.indexOf('zonder frame')>-1}
function selectedMainFrameIsNoFrame(){return isNoFrameValue(selected[frameIdx])}
function initialPriceVariant(){var matches=variants.filter(function(v){var opts=v&&v.options?v.options:[];
return v&&v.available!==false&&typeof v.price==='number'&&normalizedSize(opts[sizeIdx]).indexOf('30x40')>-1&&String(opts[detailIdx]||'').toLowerCase().indexOf('24')>-1&&isNoFrameValue(opts[frameIdx])});
if(!matches.length)matches=variants.filter(function(v){return v&&v.available!==false&&typeof v.price==='number'});
matches.sort(function(a,b){return a.price-b.price});
return matches[0]||null}
function frameSelectionActive(){return !!(frameAddon&&!frameAddon.hidden&&frameAddonCheck&&frameAddonCheck.checked&&!frameAddonCheck.disabled&&frameSelectedVariant&&frameSelectedVariant.id&&frameSelectedVariant.available!==false)}
function updateFrameWarning(){if(!frameWarning)return;
frameWarning.hidden=!(frameOfferChoice==='yes'&&frameAddon&&!frameAddon.hidden&&selectedMainFrameIsNoFrame())}
function syncFrameSelectionUI(){var chosen=frameSelectionActive();
if(frameAddon)frameAddon.classList.toggle('is-selected',chosen)}
function syncAddonSelectionUI(){Array.prototype.forEach.call(addonChecks,function(cb){var card=cb.closest('[data-pbnk-addon]');
if(card&&!card.hasAttribute('data-frame-addon'))card.classList.toggle('is-selected',!!cb.checked)})}
function updateProgress(count){var total=4,done=Math.max(0,Math.min(Number(count)||0,total));
if(progressTextEl)progressTextEl.textContent=lang==='nl'?done+' van '+total+' voltooid':done+' of '+total+' completed';
if(progressBarEl)progressBarEl.style.width=((done/total)*100)+'%'}
function syncFrameOfferUI(){Array.prototype.forEach.call(frameInterestButtons,function(button){var active=button.getAttribute('data-frame-interest')===frameOfferChoice;
button.classList.toggle('is-active',active);
button.setAttribute('aria-pressed',active?'true':'false');
if(button.getAttribute('data-frame-interest')==='yes')button.setAttribute('aria-expanded',active&&frameAddon&&!frameAddon.hidden?'true':'false')})}
function frameColorChoiceRequired(){return !!(!isUS&&frameOfferChoice==='yes'&&!frameSelectionActive())}
function showFrameColorError(show){if(frameColorError)frameColorError.hidden=!show;
if(frameColors)frameColors.setAttribute('aria-invalid',show?'true':'false');
if(frameAddon)frameAddon.classList.toggle('has-validation-error',!!show)}
function focusFrameColorChoice(){if(!frameAddon)return;
var reduceMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if(typeof frameAddon.scrollIntoView==='function'){try{frameAddon.scrollIntoView({behavior:reduceMotion?'auto':'smooth',block:'center'})}catch(e){frameAddon.scrollIntoView()}}
if(frameColors)setTimeout(function(){var first=frameColors.querySelector('[data-frame-color]:not([disabled])');
if(first)first.focus()},reduceMotion?0:250)}
function updateFrameAddon(){if(!frameAddon)return;
var eligible=!isUS&&ready&&frameSizeAllowed();
if(frameQuestion)frameQuestion.hidden=!eligible;
if(!eligible)frameOfferChoice=null;
var show=eligible&&frameOfferChoice==='yes';
frameAddon.hidden=!show;
if(!show)showFrameColorError(false);
if(!show||!ready){frameSelectedVariant=null;
frameAddon.removeAttribute('data-selected-variant-id');
if(frameAddonCheck){frameAddonCheck.checked=false;
frameAddonCheck.disabled=true}
frameAddon.querySelectorAll('.pbnk-frame-color').forEach(function(b){b.classList.remove('is-active');
b.setAttribute('aria-pressed','false')})}frameAddon.querySelectorAll('.pbnk-frame-color').forEach(function(b){b.disabled=!ready||!show});
if(frameAddonCheck)frameAddonCheck.disabled=!ready||!show||!frameSelectedVariant;
if(frameFit){var selectedSize=selected[sizeIdx]||'';
frameFit.textContent='✓ '+(lang==='nl'?'Past bij ':'Fits ')+selectedSize}
updateFrameWarning();
syncFrameSelectionUI();
syncFrameOfferUI()}
function render(){var up=uploaded();
if(uploadStatus)uploadStatus.classList.toggle('is-visible',up);
if(uploadWrap)uploadWrap.classList.toggle('has-upload',up);
var size=!!selected[sizeIdx],detail=!!selected[detailIdx],frame=!!selected[frameIdx];
lock('size',!up);
lock('detail',!(up&&size));
lock('frame',!(up&&size&&detail));
ready=!!(up&&size&&detail&&frame);
lock('upsell',!ready);
syncAddonSelectionUI();
updateFrameAddon();
if(frameProduct&&frameAddon&&!frameAddon.hidden)buildFrameColours(frameProduct);
lock('buy',!ready);
var completed=[];
if(up)completed.push('upload');
if(up&&size)completed.push('size');
if(up&&size&&detail)completed.push('detail');
if(up&&size&&detail&&frame)completed.push('frame');
updateProgress(completed.length);
var current='upload';
if(up&&!size)current='size';
else if(up&&size&&!detail)current='detail';
else if(up&&size&&detail&&!frame)current='frame';
else if(ready)current='upsell';
setGuide(current,completed);
scrollToGuide(current);
var exact=null;
if(ready){exact=findExact(selected);
if(exact){updateURL(exact.id);
syncMini(exact);
updateThemePriceSoon(exact)}}buyState(exact)}
function info(){var tog=root.querySelector('[data-pbnk-info-toggle]'),pop=root.querySelector('[data-pbnk-info-popover]');
if(!tog||!pop)return;
tog.addEventListener('click',function(e){e.preventDefault();
e.stopPropagation();
var open=pop.classList.contains('is-open');
pop.classList.toggle('is-open',!open);
tog.setAttribute('aria-expanded',!open?'true':'false')});
document.addEventListener('click',function(e){if(!pop.contains(e.target)&&!tog.contains(e.target)){pop.classList.remove('is-open');
tog.setAttribute('aria-expanded','false')}});
document.addEventListener('keydown',function(e){if(e.key==='Escape'){pop.classList.remove('is-open');
tog.setAttribute('aria-expanded','false')}})}
function props(){var out={},area=root.querySelector('.uploadkit')||document,nodes=area.querySelectorAll('input[name^="properties["],textarea[name^="properties["],select[name^="properties["]');
nodes.forEach(function(el){if(!el.name)return;
var m=el.name.match(/^properties\[(.+)\]$/);
if(!m)return;
var key=m[1];
if(el.type==='checkbox'){if(el.checked)out[key]=el.value||'Yes';
return}if(el.type==='radio'){if(el.checked)out[key]=el.value;
return}var val=el.value!=null?String(el.value).trim():'';
if(val!=='')out[key]=val});
return out}function shopifyRoute(path){var base=window.Shopify&&Shopify.routes&&Shopify.routes.root?String(Shopify.routes.root):'/';
if(base.charAt(base.length-1)!=='/')base+='/';
return base+String(path||'').replace(/^\/+/, '')}async function addMain(id,qty){var res=await fetch(shopifyRoute('cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:Number(qty||1),properties:props()}]})});
if(!res.ok)throw new Error('add_failed');
return await res.json()}async function addAddon(id,qty){if(!qty||qty<=0||!id)return;
var res=await fetch(shopifyRoute('cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:qty}]})});
if(!res.ok)throw new Error('addon_failed');
return await res.json()}
function openCart(){var d=document.querySelector('m-cart-drawer');
if(d){if(typeof d.onCartDrawerUpdate==='function')d.onCartDrawerUpdate(true);
if(typeof d.open==='function'){d.open();
return}}window.location.href=shopifyRoute('cart')}
function marketCurrencyRate(){var rate=1;
if(window.Shopify&&Shopify.currency&&Shopify.currency.rate){rate=parseFloat(Shopify.currency.rate);
if(isNaN(rate)||rate<=0)rate=1}return rate}
function bundleDiscountPresentmentCents(){return Math.max(0,Math.round(bundleDiscountUsdCents*marketCurrencyRate()))}
function addonPrices(){root.querySelectorAll('[data-addon-price],[data-addon-compare]').forEach(function(el){var base=parseInt(el.getAttribute('data-cents'),10);
if(isNaN(base))return;
if(el.hasAttribute('data-addon-compare')){el.textContent=(pbnkLang==='nl'?'Van: ':'Was: ')+money(base)}else{el.textContent=money(base)}})}
function updateBundleAddonPrice(card,variant){if(!card||card.hasAttribute('data-frame-addon'))return;
var source=variant&&typeof variant.price==='number'?parseInt(variant.price,10):parseInt(card.getAttribute('data-market-price-cents'),10),pe=card.querySelector('[data-addon-price]'),ce=card.querySelector('[data-addon-compare]');
if(isNaN(source)||source<=0){if(pe){pe.removeAttribute('data-cents');
pe.textContent=''}if(ce){ce.removeAttribute('data-cents');
ce.textContent='';
ce.hidden=true}return}card.setAttribute('data-market-price-cents',String(source));
var bundlePrice=Math.max(0,source-bundleDiscountPresentmentCents());
if(pe){pe.setAttribute('data-cents',String(bundlePrice));
pe.setAttribute('data-presentment','true');
pe.removeAttribute('aria-busy')}
if(ce){ce.setAttribute('data-cents',String(source));
ce.setAttribute('data-presentment','true');
ce.removeAttribute('aria-busy');
ce.hidden=source<=bundlePrice}addonPrices()}
function initialBundleAddonPrices(){root.querySelectorAll('[data-pbnk-addon]:not([data-frame-addon])').forEach(function(card){updateBundleAddonPrice(card,null)})}
function setGalleryImage(index){if(!frameImages.length||!lightboxImg)return;
lightboxIndex=Math.max(0,Math.min(index,frameImages.length-1));
lightboxImg.src=frameImages[lightboxIndex];
if(frameThumbs)frameThumbs.querySelectorAll('[data-gallery-index]').forEach(function(b){b.classList.toggle('is-active',parseInt(b.getAttribute('data-gallery-index'),10)===lightboxIndex)});
if(lightboxThumbs)lightboxThumbs.querySelectorAll('[data-gallery-index]').forEach(function(b){b.classList.toggle('is-active',parseInt(b.getAttribute('data-gallery-index'),10)===lightboxIndex)})}
function buildGallery(images){frameImages=(images||[]).filter(Boolean).filter(function(src,i,a){return a.indexOf(src)===i});
if(!frameImages.length)return;
var main=frameAddon&&frameAddon.querySelector('.pbnk-addon-image');
if(main){main.src=frameImages[0];
main.classList.add('is-loaded')}if(frameThumbs){frameThumbs.innerHTML='';
frameImages.slice(1,6).forEach(function(src,i){var galleryIndex=i+1,b=document.createElement('button');
b.type='button';
b.className='pbnk-frame-thumb';
b.setAttribute('data-lightbox-open','');
b.setAttribute('data-gallery-index',String(galleryIndex));
b.setAttribute('aria-label','View frame image '+(galleryIndex+1));
b.innerHTML='<img src="'+src.replace(/"/g,'&quot;')+'" alt="" loading="lazy">';
frameThumbs.appendChild(b)})}if(lightboxThumbs){lightboxThumbs.innerHTML='';
frameImages.forEach(function(src,i){var b=document.createElement('button');
b.type='button';
b.className='pbnk-lightbox-thumb'+(i===0?' is-active':'');
b.setAttribute('data-gallery-index',String(i));
b.setAttribute('aria-label','View frame image '+(i+1));
b.innerHTML='<img src="'+src.replace(/"/g,'&quot;')+'" alt="" loading="lazy">';
lightboxThumbs.appendChild(b)})}setGalleryImage(0)}
function normalizeOption(v){return String(v||'').toLowerCase().replace(/[×*✕✖]/g,'x').replace(/\s+/g,'').replace(/cm/g,'')}
function canonicalFrameSize(v){var x=normalizeOption(v),sizes=['30x40','40x40','40x50','50x60'];
for(var i=0;
i<sizes.length;
i++){if(x.indexOf(sizes[i])>-1)return sizes[i]}return''}
function frameSizeMatches(v,size){if(!size)return false;
var text=(v.options||[]).join(' ')+' '+(v.title||''),metric=canonicalFrameSize(text);
if(metric)return metric===size;
var inches={'30x40':'12x16','40x40':'16x16','40x50':'16x20','50x60':'20x24'},normalized=normalizeOption(text);
return inches[size]?normalized.indexOf(inches[size])>-1:false}
function colorKeyFromText(v){var x=String(v||'').toLowerCase();
if(x.indexOf('black')>-1||x.indexOf('zwart')>-1)return'black';
if(x.indexOf('gold')>-1||x.indexOf('goud')>-1)return'gold';
return''}
function variantImage(v,p,colour){var src='';
if(v&&v.featured_image){src=typeof v.featured_image==='string'?v.featured_image:(v.featured_image.src||'')}if(src)return src;
var imgs=(p.images||[]).map(function(x){return typeof x==='string'?x:(x&&x.src?x.src:'')}).filter(Boolean);
var match=imgs.filter(function(x){return String(x).toLowerCase().indexOf(colour)>-1})[0];
return match||p.featured_image||imgs[0]||''}
function matchingFrameVariant(colour){if(!frameProduct)return null;
var size=canonicalFrameSize(selected[sizeIdx]);
if(!size)return null;
var exact=(frameProduct.variants||[]).filter(function(v){var text=(v.options||[]).join(' ')+' '+(v.title||'');
return colorKeyFromText(text)===colour&&frameSizeMatches(v,size)});
if(!exact.length)return null;
var available=exact.filter(function(v){return v.available!==false});
return available[0]||exact[0]}
function updateFramePrice(){if(!frameAddon||!frameProduct)return;
var pe=frameAddon.querySelector('[data-addon-price]'),ce=frameAddon.querySelector('[data-frame-compare]');
if(!pe)return;
var v=frameSelectedVariant;
if(!v){var options=['black','gold'].map(function(colour){return matchingFrameVariant(colour)}).filter(function(x){return x&&x.available!==false&&typeof x.price==='number'});
if(options.length){v=options.reduce(function(low,x){return x.price<low.price?x:low},options[0])}}if(v&&typeof v.price==='number'){var productPrice=parseInt(v.price,10),bundlePrice=Math.max(0,productPrice-bundleDiscountPresentmentCents());
pe.setAttribute('data-cents',String(bundlePrice));
pe.setAttribute('data-presentment','true');
if(ce){if(!isNaN(productPrice)&&productPrice>bundlePrice){ce.setAttribute('data-cents',String(productPrice));
ce.setAttribute('data-presentment','true');
ce.hidden=false}else{ce.removeAttribute('data-cents');
ce.removeAttribute('data-presentment');
ce.textContent='';
ce.hidden=true}}addonPrices()}else{pe.removeAttribute('data-cents');
pe.removeAttribute('data-presentment');
pe.textContent='';
if(ce){ce.removeAttribute('data-cents');
ce.removeAttribute('data-presentment');
ce.textContent='';
ce.hidden=true}}}
function clearFrameSelection(){frameSelectedVariant=null;
if(frameAddon){frameAddon.removeAttribute('data-selected-variant-id');
frameAddon.querySelectorAll('.pbnk-frame-color').forEach(function(b){b.classList.remove('is-active');
b.setAttribute('aria-pressed','false')})}if(frameAddonCheck){frameAddonCheck.checked=false;
frameAddonCheck.disabled=true}updateFramePrice();
updateFrameWarning();
syncFrameSelectionUI();
if(activeVariant)buyState(activeVariant)}
function setFrameOfferChoice(choice){if(isUS||!frameQuestion||(choice!=='yes'&&choice!=='no'))return;
frameOfferChoice=choice;
if(choice==='no'){showFrameColorError(false);
clearFrameSelection()}
updateFrameAddon();
if(choice==='yes'&&frameProduct&&frameAddon&&!frameAddon.hidden)buildFrameColours(frameProduct);
syncFrameOfferUI();
if(activeVariant)buyState(activeVariant)}
function selectFrameColour(colour,button){if(button&&button.classList.contains('is-active')&&frameSelectionActive()){clearFrameSelection();
return}
var v=matchingFrameVariant(colour);
if(!v||v.available===false)return;
frameSelectedVariant=v;
frameAddon.setAttribute('data-selected-variant-id',String(v.id));
frameAddon.querySelectorAll('.pbnk-frame-color').forEach(function(b){var active=b===button;
b.classList.toggle('is-active',active);
b.setAttribute('aria-pressed',active?'true':'false')});
if(frameAddonCheck){frameAddonCheck.disabled=!ready;
frameAddonCheck.checked=!!ready}showFrameColorError(false);
updateFramePrice();
updateFrameWarning();
syncFrameSelectionUI();
if(activeVariant)buyState(activeVariant)}
function buildFrameColours(p){if(!frameColors)return;
frameColors.innerHTML='';
['black','gold'].forEach(function(colour){var exact=matchingFrameVariant(colour),fallback=(p.variants||[]).filter(function(x){return colorKeyFromText((x.options||[]).join(' ')+' '+(x.title||''))===colour})[0],imageVariant=exact||fallback;
if(!imageVariant)return;
var b=document.createElement('button');
b.type='button';
b.className='pbnk-frame-color';
b.setAttribute('data-frame-color',colour);
b.setAttribute('data-color-key',colour);
b.setAttribute('aria-pressed','false');
b.disabled=!ready||!exact||exact.available===false;
if(!exact)b.setAttribute('aria-label',t('This color is unavailable for the selected canvas size','Deze kleur is niet beschikbaar voor het gekozen canvasformaat','This colour is unavailable for the selected canvas size'));
var img=document.createElement('img');
img.className='pbnk-frame-color-image';
img.loading='lazy';
img.alt=colour==='black'?t('Black aluminum frame','Zwart aluminium frame','Black aluminium frame'):t('Gold aluminum frame','Goud aluminium frame','Gold aluminium frame');
img.src=variantImage(imageVariant,p,colour);
var name=document.createElement('span');
name.className='pbnk-frame-color-name';
name.innerHTML='<span class="pbnk-frame-color-swatch"></span><span>'+(colour==='black'?t('Black','Zwart'):t('Gold','Goud'))+'</span>';
var check=document.createElement('span');
check.className='pbnk-frame-color-check';
check.textContent='✓';
b.appendChild(img);
b.appendChild(name);
b.appendChild(check);
frameColors.appendChild(b)});
if(frameSelectedVariant){var current=colorKeyFromText((frameSelectedVariant.options||[]).join(' ')+' '+(frameSelectedVariant.title||'')),updated=matchingFrameVariant(current),currentBtn=frameColors.querySelector('[data-frame-color="'+current+'"]');
if(updated&&updated.available!==false&&currentBtn){frameSelectedVariant=updated;
frameAddon.setAttribute('data-selected-variant-id',String(updated.id));
currentBtn.classList.add('is-active');
currentBtn.setAttribute('aria-pressed','true')}else{frameSelectedVariant=null;
frameAddon.removeAttribute('data-selected-variant-id')}}else{frameAddon.removeAttribute('data-selected-variant-id')}if(frameAddonCheck){frameAddonCheck.disabled=!ready||!frameSelectedVariant;
if(!frameSelectedVariant||!ready)frameAddonCheck.checked=false}
updateFramePrice();
updateFrameWarning();
syncFrameSelectionUI()}
function addonAssets(){root.querySelectorAll('[data-product-handle]').forEach(function(c){var h=c.getAttribute('data-product-handle'),i=c.querySelector('.pbnk-addon-image');
if(!h||!i||c.__img)return;
c.__img=1;
fetch(shopifyRoute('products/'+encodeURIComponent(h)+'.js')).then(function(r){if(!r.ok)throw new Error('product_load_failed');
return r.json()}).then(function(p){var images=(p.images||[]).map(function(x){return typeof x==='string'?x:(x&&x.src?x.src:'')}).filter(Boolean),src=p.featured_image||images[0];
if(c.hasAttribute('data-frame-addon')){frameProduct=p;
buildGallery(images.length?images:[src]);
buildFrameColours(p)}else{var variantId=parseInt(c.getAttribute('data-variant-id'),10),addonVariant=(p.variants||[]).filter(function(x){return Number(x.id)===variantId})[0];
if(addonVariant)updateBundleAddonPrice(c,addonVariant);
if(src){i.src=src;
i.classList.add('is-loaded')}}}).catch(function(){})})}
function lockBodyScroll(){lockedScrollY=window.scrollY||document.documentElement.scrollTop||0;
document.body.style.position='fixed';
document.body.style.top='-'+lockedScrollY+'px';
document.body.style.left='0';
document.body.style.right='0';
document.body.style.width='100%'}
function unlockBodyScroll(){document.body.style.position='';
document.body.style.top='';
document.body.style.left='';
document.body.style.right='';
document.body.style.width='';
window.scrollTo(0,lockedScrollY)}
function showLightbox(){if(!lightbox)return;
if(!lightbox.classList.contains('is-open'))lockBodyScroll();
lightbox.classList.add('is-open');
lightbox.setAttribute('aria-hidden','false')}
function openLightbox(index){if(!lightbox||!frameImages.length)return;
if(lightboxThumbs)lightboxThumbs.hidden=false;
if(lightboxImg)lightboxImg.alt=t('Aluminum Gallery Frame','Aluminium galerieframe','Aluminium Gallery Frame');
if(lightboxDialog)lightboxDialog.setAttribute('aria-label',t('Aluminum Gallery Frame gallery','Galerij van aluminium galerieframe','Aluminium Gallery Frame gallery'));
setGalleryImage(index||0);
showLightbox()}
function openAddonLightbox(trigger){if(!lightbox||!lightboxImg||!trigger)return false;
var img=trigger.querySelector('img'),src=img?(img.currentSrc||img.getAttribute('src')||''):'';
if(!src)return false;
var alt=img.getAttribute('alt')||t('Product image','Productafbeelding');
lightboxImg.src=src;
lightboxImg.alt=alt;
if(lightboxThumbs)lightboxThumbs.hidden=true;
if(lightboxDialog)lightboxDialog.setAttribute('aria-label',alt);
showLightbox();
return true}
function closeLightbox(){if(!lightbox||!lightbox.classList.contains('is-open'))return;
lightbox.classList.remove('is-open');
lightbox.setAttribute('aria-hidden','true');
unlockBodyScroll()}
function lightboxInit(){if(!lightbox)return;
if(lightbox.parentElement!==document.body)document.body.appendChild(lightbox);
document.addEventListener('click',function(e){var addonOpen=e.target.closest('[data-addon-lightbox]');
if(addonOpen&&root.contains(addonOpen)){if(openAddonLightbox(addonOpen)){e.preventDefault();
e.stopPropagation();
}return}var open=e.target.closest('[data-lightbox-open]');
if(open&&root.contains(open)){e.preventDefault();
e.stopPropagation();
openLightbox(parseInt(open.getAttribute('data-gallery-index'),10)||0);
return}var thumb=e.target.closest('.pbnk-lightbox-thumb');
if(thumb&&lightbox.contains(thumb)){e.preventDefault();
setGalleryImage(parseInt(thumb.getAttribute('data-gallery-index'),10)||0);
return}if(e.target===lightbox||e.target.closest('[data-lightbox-close]'))closeLightbox()});
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeLightbox()})}
function selectedAddons(){var items=[];
root.querySelectorAll('[data-pbnk-addon]:not([data-frame-addon])').forEach(function(card){var cb=card.querySelector('[data-addon-check]');
var id=parseInt(card.getAttribute('data-variant-id'),10);
if(cb&&cb.checked&&!cb.disabled&&id)items.push(id)});
if(frameSelectionActive()&&frameSelectedVariant.id)items.unshift(Number(frameSelectedVariant.id));
return items}root.addEventListener('click',function(e){var colourBtn=e.target.closest('[data-frame-color]');
if(colourBtn&&root.contains(colourBtn)){e.preventDefault();
if(!colourBtn.disabled)selectFrameColour(colourBtn.getAttribute('data-frame-color'),colourBtn);
return}var frameInterestButton=e.target.closest('[data-frame-interest]');
if(frameInterestButton&&root.contains(frameInterestButton)){e.preventDefault();
if(!frameInterestButton.disabled)setFrameOfferChoice(frameInterestButton.getAttribute('data-frame-interest'));
return}var card=e.target.closest('[data-pbnk-addon]');
if(card&&!card.hasAttribute('data-frame-addon')&&!e.target.closest('a')&&!e.target.closest('[data-lightbox-open]')){if(e.target.closest('input[type="checkbox"],.pbn-checkmark'))return;
e.preventDefault();
var cb=card.querySelector('[data-addon-check]');
if(cb&&!cb.disabled){cb.checked=!cb.checked;
cb.dispatchEvent(new Event('change',{bubbles:true}))}return}var b=e.target.closest('.pbnk-tile-btn');
if(!b||b.disabled)return;
var idx=parseInt(b.getAttribute('data-option-index'),10),val=b.getAttribute('data-value');
if(isNaN(idx))return;
selected[idx]=val;
setActive(idx,val);
msg('');
render()});
root.addEventListener('change',function(e){var addonCheck=e.target.closest('[data-addon-check],[data-frame-addon-check]');
if(addonCheck){updateFrameWarning();
if(addonCheck===frameAddonCheck)syncFrameSelectionUI();
else syncAddonSelectionUI();
if(activeVariant)buyState(activeVariant);
return}var s=e.target.closest('[data-pbnk-select]');
if(!s)return;
var idx=parseInt(s.getAttribute('data-option-index'),10);
if(isNaN(idx))return;
selected[idx]=s.value||null;
msg('');
render()});
if(form){form.addEventListener('submit',async function(e){e.preventDefault();
render();
if(!ready||!activeVariant||!activeVariant.id){msg(t('Please complete all steps before adding to cart.','Maak eerst alle stappen compleet voordat je toevoegt aan de winkelwagen.'));
return}if(!uploaded()){msg(t('Please upload your photo first.','Upload eerst je foto.'));
return}if(activeVariant.available===false){msg(t('This option is currently sold out.','Deze optie is momenteel uitverkocht.'));
return}if(frameColorChoiceRequired()){msg('');
showFrameColorError(true);
focusFrameColorChoice();
return}var qty=qtyInput&&qtyInput.value?Number(qtyInput.value)||1:1;
if(btnEl)btnEl.setAttribute('disabled','disabled');
if(textEl)textEl.textContent=t('Adding...','Toevoegen...');
msg('');
try{await addMain(activeVariant.id,qty);
var addons=selectedAddons();
for(var ai=0;
ai<addons.length;
ai++){await addAddon(addons[ai],qty)}openCart()}catch(err){msg(t('Something went wrong. Please try again.','Er ging iets mis. Probeer het opnieuw.'))}finally{render()}})}
function observeUpload(){var area=root.querySelector('.uploadkit');
if(!area||!window.MutationObserver)return;
var timer=null;
new MutationObserver(function(){clearTimeout(timer);
timer=setTimeout(render,150)}).observe(area,{childList:true,subtree:true,attributes:true,characterData:true});
area.addEventListener('change',function(){setTimeout(render,250);
setTimeout(render,1000);
setTimeout(render,2000)})}
function observeDyn(){if(!dyn||!window.MutationObserver)return;
new MutationObserver(function(){dynDisabled(!ready||!activeVariant||activeVariant.available===false)}).observe(dyn,{childList:true,subtree:true})}info();
initialBundleAddonPrices();
addonAssets();
lightboxInit();
hidePicker(miniPicker());
observeUpload();
observeDyn();
render();
if(!activeVariant){var initialVariant=initialPriceVariant();
if(initialVariant)updateInitialThemePriceSoon(initialVariant)}})();
